import {
  BookingServiceV2Api,
  Configuration,
  V1CalendarRequest,
  V1CalendarResponse,
} from '@ennismore/ows-api-client';
import { UseQueryOptions, useQuery } from 'react-query';

import { useKongEnnismoreApiClientConfig } from '@/api';
import { useSkipRedirectSwitch } from '@/availability-fallback/hooks';
import { mapNetworkError } from '@/errors';
import { useLogger } from '@/logging';

import { AvailabilitySearchError } from '../../availability/models/availability-search.error';

export const useAvailabilityCalendar = (
  args: V1CalendarRequest,
  options: UseQueryOptions<V1CalendarResponse, AvailabilitySearchError> = {}
) => {
  const kongApiClient = useKongEnnismoreApiClientConfig();
  const logger = useLogger();
  const [skipRedirect] = useSkipRedirectSwitch();

  return useQuery<V1CalendarResponse, AvailabilitySearchError>(
    ['availabilityCalendar', args],
    async () => {
      logger.debug('loading calendar', args.from, args.to, args.roomCode);

      try {
        // TODO: Hacking this in here as the weekly calendar for OWS will be removed in the future
        const client = new BookingServiceV2Api(
          new Configuration({
            apiKey: kongApiClient.apiKey,
            basePath: kongApiClient.baseUrl,
          })
        );
        const { data } = await client.bookingServiceV2Calendar(args, {
          headers: { 'X-Skip-Redirect': skipRedirect },
        });

        return data;
      } catch (e) {
        throw new AvailabilitySearchError(await mapNetworkError(e));
      }
    },
    {
      // refetchOnWindowFocus: false,
      // refetchOnMount: false,
      staleTime: 15 * 60e3, // 15 mins
      ...options,
    }
  );
};
